export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-8])|([12][0-4])|([37][0-3])|([45][0-5])|([689][0-2]))[0-9]{4}$/));
    }
}
